import { useImageUploader } from '@hooks/useImageKit'
import { doc, deleteDoc } from 'firebase/firestore'
import styles from '@styles/CrudProduct.module.css'
import PropTypes from 'prop-types'
import { db } from '@lib/firebase'

const OfferTable = ({ offers, onDelete, onEdit, onToggleStatus, formatPrice, darkMode }) => {
  const { handleDeleteImage } = useImageUploader()

  return (
    <div className={styles.tableContainer}>
      <table className={`${styles.table} ${darkMode ? styles.dark : ''}`}>
        <thead>
          <tr>
            <th className={styles.tableHeader}>ID</th>
            <th className={styles.tableHeader}>Imagen</th>
            <th className={styles.tableHeader}>Título</th>
            <th className={styles.tableHeader}>Precio Original</th>
            <th className={styles.tableHeader}>Precio Descuento</th>
            <th className={styles.tableHeader}>% Descuento</th>
            <th className={styles.tableHeader}>Válido Hasta</th>
            <th className={styles.tableHeader}>Estado</th>
            <th className={styles.tableHeader}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {offers.map(offer => (
            <tr key={offer.id}>
              <td className={styles.tableCell} data-label='ID'>{offer.id}</td>
              <td className={styles.tableCell} data-label='Imagen'>
                {offer.image ? (
                  <img
                    src={offer.image.url || offer.image}
                    alt={offer.title}
                    className={styles.productImage}
                  />
                ) : (
                  <span>No hay imagen</span>
                )}
              </td>
              <td className={styles.tableCell} data-label='Título'>{offer.title}</td>
              <td className={styles.tableCell} data-label='Precio Original'>
                {formatPrice(offer.originalPrice)}
              </td>
              <td className={styles.tableCell} data-label='Precio Descuento'>
                {formatPrice(offer.discountedPrice)}
              </td>
              <td className={styles.tableCell} data-label='% Descuento'>{offer.discountPercentage}%</td>
              <td className={styles.tableCell} data-label='Válido Hasta'>{offer.validUntil}</td>
              <td className={styles.tableCell} data-label='Estado'>
                <button
                  onClick={() => onToggleStatus(offer.id, offer.active)}
                  className={
                    offer.active ? styles.activeButton : styles.inactiveButton
                  }
                >
                  {offer.active ? 'Activo' : 'Inactivo'}
                </button>
              </td>
              <td className={styles.tableCell} data-label='Acciones'>
                <button
                  onClick={async () => {
                    await onDelete(offer.id)
                    await handleDeleteImage(offer.image.fileId)
                    await deleteDoc(doc(db, 'offers', offer.id))
                  }}
                  className={styles.deleteButton}
                >
                  Eliminar
                </button>
                <button
                  onClick={() => onEdit(offer)}
                  className={styles.updateButton}
                >
                  Editar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}


OfferTable.propTypes = {
  offers: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onToggleStatus: PropTypes.func.isRequired,
  formatPrice: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
}

export default OfferTable
